import React, { useState } from 'react';
import { videoAPI } from '../../services/api';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const VIDEO_CATEGORIES = ['Interviews', 'Bangalore Metro TV', 'Karnataka Police TV'];
const VideoForm = ({ onVideoCreated }) => {
    const [formData, setFormData] = useState({
        video_title: '',
        video_category: '',
        video_url: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await videoAPI.create(formData);
            setFormData({ video_title: '', video_url: '', video_category: '' });
            if (onVideoCreated) onVideoCreated(response.data.data);
            toast.success('Video added successfully!');
        } catch (err) {
            console.error(err);
            const errors = err.response?.data?.errors;
            setError(errors || 'Something went wrong');
            if (errors) toast.error(JSON.stringify(errors));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main-content">
            <div className="content-wrapper">
                <div className="form-card">
                    <div className="form-card-header">
                        <h5 className="text-white"><i className="fas fa-video me-2"></i>Add Video</h5>
                        {error && <div className="error">{JSON.stringify(error)}</div>}
                    </div>
                    <div className="form-card-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row g-3 mb-3">
                                <div className="col-md-4">
                                    <label>Video Title</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="video_title"
                                        value={formData.video_title}
                                        onChange={handleChange}
                                        required
                                    />
                                </div>
                                <div className="col-md-4">
                                    <label>Category</label>
                                    <select
                                        className="form-control"
                                        name="video_category"
                                        value={formData.video_category}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select</option>
                                        {VIDEO_CATEGORIES.map(cat => (
                                            <option key={cat} value={cat}>{cat}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label>Video URL (YouTube, Vimeo, etc.)</label>
                                    <input
                                        type="url"
                                        className="form-control"
                                        name="video_url"
                                        value={formData.video_url}
                                        onChange={handleChange}
                                        placeholder="https://www.youtube.com/watch?v=..."
                                        required
                                    />
                                </div>
                            </div>
                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                {loading ? 'Wait Please...' : 'Add Video'}
                            </button>
                        </form>
                    </div>
                    <ToastContainer />
                </div>
            </div>
        </div>
    );
};

export default VideoForm;